var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-data-provider-connect',_vm._b({on:{"custom-form:500-error":_vm.handle500,"custom-form:404-error":_vm.handle404,"custom-form:429-error":_vm.handle429,"custom-form:422-error":_vm.handle422}},'form-data-provider-connect',_vm.dataProviderConfig,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }